import Vue from "vue";
import Router from "vue-router";

import { auth } from "@/auth";
import store from "@/store/root";

import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import ConfirmSignIn from "@/views/ConfirmSignIn.vue";
import CompleteSignUp from "@/views/CompleteSignUp.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import ForgotPasswordSubmit from "@/views/ForgotPasswordSubmit.vue";

Vue.use(Router);

const mustBeAuthenticated = async (to: any, from: any, next: any) => {
  try {
    if (!auth.enabled) return next();

    if ((await auth.groups()).length === 0) {
      store.dispatch("alerts/flash", {
        type: "danger",
        message: "You don't have the necessary permissions."
      });

      next("/login");
    }

    next(Object.keys(await auth.user()).length > 0 ? undefined : "/login");
  } catch (e) {
    next("/login");
  }
};

const mustNotBeAuthenticated = async (to: any, from: any, next: any) => {
  try {
    next(
      auth.enabled &&
        (Object.keys(await auth.user()).length === 0 ||
          (await auth.groups()).length === 0)
        ? undefined
        : "/"
    );
  } catch (e) {
    next();
  }
};

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: mustBeAuthenticated
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: mustNotBeAuthenticated
    },
    {
      path: "/finish",
      name: "finish",
      component: CompleteSignUp
    },
    {
      path: "/complete-mfa",
      name: "complete-mfa",
      component: ConfirmSignIn
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: ForgotPassword,
      beforeEnter: mustNotBeAuthenticated
    },
    {
      path: "/forgot-password-submit",
      name: "forgot-password-submit",
      component: ForgotPasswordSubmit,
      beforeEnter: mustNotBeAuthenticated
    }
  ]
});
